import {
  GET_PHAN_QUYEN_CAM_DO,
  GET_PHAN_QUYEN_CAM_DO_SUCCESS,
  GET_PHAN_QUYEN_CAM_DO_FAILURE,
  GET_PHAN_QUYEN_TIN_CHAP,
  GET_PHAN_QUYEN_TIN_CHAP_SUCCESS,
  GET_PHAN_QUYEN_TIN_CHAP_FAILURE,
  GET_PHAN_QUYEN_NO_PHAI_THU,
  GET_PHAN_QUYEN_NO_PHAI_THU_SUCCESS,
  GET_PHAN_QUYEN_NO_PHAI_THU_FAILURE,
  GET_PHAN_QUYEN_TRA_GOP,
  GET_PHAN_QUYEN_TRA_GOP_SUCCESS,
  GET_PHAN_QUYEN_TRA_GOP_FAILURE,
} from 'actions/PhanQuyen/actionTypes';

const initialState = {
  PhanQuyenCamDo: [],
  getPhanQuyenCamDoLoading: false,
  PhanQuyenTinChap:  [],
  getPhanQuyenTinChapLoading: false,
  getPhanQuyenNoPhaiThuLoading: false,
  PhanQuyenNoPhaiThu: [],
  PhanQuyenTraGop: [],
  getPhanQuyenSuccess : false,
};

const getPhanQuyenCamDo = (state, action) => ({
  ...state,
  getPhanQuyenCamDoLoading: true,
});

const getPhanQuyenCamDoSuccess = (state, action) => {
  return {
    ...state,
    getPhanQuyenCamDoLoading: false,
    getPhanQuyenSuccess : true,
    PhanQuyenCamDo: action.payload,
  };
};

const getPhanQuyenCamDoFailed = (state, action) => ({
  ...state,
  getPhanQuyenCamDoLoading: false,
  getPhanQuyenSuccess : false,
  PhanQuyenCamDo: [],
});
const getPhanQuyenTinChap = (state, action) => ({
  ...state,
  getPhanQuyenTinChapLoading: true,
  getPhanQuyenSuccess : false,
});

const getPhanQuyenTinChapSuccess = (state, action) => {
  return {
    ...state,
    getPhanQuyenTinChapLoading: false,
    PhanQuyenTinChap: action.payload,
    getPhanQuyenSuccess: true,
  };
};

const getPhanQuyenTinChapFailed = (state, action) => ({
  ...state,
  getPhanQuyenTinChapLoading: false,
  PhanQuyenTinChap: [],
  getPhanQuyenSuccess: false
});

const getPhanQuyenNoPhaiThu = (state, action) => ({
  ...state,
  getPhanQuyenNoPhaiThuLoading: true,
  getPhanQuyenSuccess: false,
});

const getPhanQuyenNoPhaiThuSuccess = (state, action) => {
  return {
    ...state,
    getPhanQuyenNoPhaiThuLoading: false,
    PhanQuyenNoPhaiThu: action.payload,
    getPhanQuyenSuccess: true,
  };
};

const getPhanQuyenNoPhaiThuFailed = (state, action) => ({
  ...state,
  getPhanQuyenNoPhaiThuLoading: false,
  PhanQuyenNoPhaiThu: [],
  getPhanQuyenSuccess: false,
});

const getPhanQuyenTraGop = (state, action) => ({
  ...state,
  getPhanQuyenTraGopLoading: true,
  getPhanQuyenSuccess: false,
});

const getPhanQuyenTraGopSuccess = (state, action) => {
  return {
    ...state,
    getPhanQuyenTraGopLoading: false,
    PhanQuyenTraGop: action.payload,
    getPhanQuyenSuccess: true,
  };
};

const getPhanQuyenTraGopFailed = (state, action) => ({
  ...state,
  getPhanQuyenTraGopLoading: false,
  PhanQuyenTraGop: [],
  getPhanQuyenSuccess: false,
});
const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PHAN_QUYEN_CAM_DO:
      return getPhanQuyenCamDo(state, action);
    case GET_PHAN_QUYEN_CAM_DO_SUCCESS:
      return getPhanQuyenCamDoSuccess(state, action);
    case GET_PHAN_QUYEN_CAM_DO_FAILURE:
      return getPhanQuyenCamDoFailed(state, action);
    case GET_PHAN_QUYEN_TRA_GOP:
      return getPhanQuyenTraGop(state, action);
    case GET_PHAN_QUYEN_TRA_GOP_SUCCESS:
      return getPhanQuyenTraGopSuccess(state, action);
    case GET_PHAN_QUYEN_TRA_GOP_FAILURE:
      return getPhanQuyenTraGopFailed(state, action);
    case GET_PHAN_QUYEN_TIN_CHAP:
      return getPhanQuyenTinChap(state, action);
    case GET_PHAN_QUYEN_TIN_CHAP_SUCCESS:
      return getPhanQuyenTinChapSuccess(state, action);
    case GET_PHAN_QUYEN_TIN_CHAP_FAILURE:
      return getPhanQuyenTinChapFailed(state, action);
    case GET_PHAN_QUYEN_NO_PHAI_THU:
      return getPhanQuyenNoPhaiThu(state, action);
    case GET_PHAN_QUYEN_NO_PHAI_THU_SUCCESS:
      return getPhanQuyenNoPhaiThuSuccess(state, action);
    case GET_PHAN_QUYEN_NO_PHAI_THU_FAILURE:
      return getPhanQuyenNoPhaiThuFailed(state, action);
    default:
      return state;
  }
};

export default storeReducer;
